import { ALLOW_LIST_USERS } from "@/app/app-constants";
import { AuthInfo } from "@/app/types";

/**
 * Checks whether a username is in the application's allow list.
 * Uses substring matching — returns true if the username contains
 * any entry from ALLOW_LIST_USERS.
 *
 * @param username - The username string to check
 * @returns true if the username matches an allow-listed user
 */
export const isAllowListedUser = (username?: string): boolean => {
  if (!username) return false;
  return ALLOW_LIST_USERS.some((user) => username.includes(user));
};

/**
 * Convenience wrapper that extracts the username from an AuthInfo
 * object and delegates to isAllowListedUser.
 *
 * @param authInfo - The authentication info object from Redux state
 * @returns true if the user in authInfo is allow-listed
 */
export const isAllowListedAuthInfo = (authInfo?: AuthInfo): boolean => {
  return isAllowListedUser(authInfo?.context?.userName);
};
